<i18n src="../../locales/lang.json"></i18n>
<template>
  <div class="container-fluid px-0">
    <div class="row">
      <div class="col-12 pb-2">
        {{$t('settings')}}
      </div>
    </div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12 px-0">
          <form class="login-formx form-validate" action="index.html" onsubmit="return false" id="updateSettingform">
            <div class="form-group row mt-1">
              <div class="col-lg-12">
                <input-checkbox @input="setOverride" v-bind:value="1" v-bind:id="'chk_disableShift'"
                                v-bind:name="'chk_disableShift'" v-bind:checked="isShiftDisable"
                                v-bind:text="$store.translate('disable_shift_change')" class="mt-1"></input-checkbox>


              </div>
            </div>

            <div class="row mt-3">
              <div class="col-lg-12 custom-form-label">
                {{$t('show/hide sections')}}
              </div>
            </div>
            <div class="form-group row mt-1">
              <div class="col-lg-12">
                <div v-for="section in sections">
                  <input-checkbox @input="setSectionOverride" v-bind:value="section.sectionname" v-bind:id="'chk_' +  section.sectionname"
                                  v-bind:name="'chk_' +  section.sectionname" v-bind:checked="isSectionAdded(section.sectionname)"
                                  v-bind:text="section.sectionname" class="mt-1"></input-checkbox>

                  <div v-for="subsection in section.subsections">
                    <input-checkbox @input="setSubSectionOverride" v-bind:value="subsection" v-bind:id="'chk_' +  subsection"
                                    v-bind:name="'chk_' +  subsection" v-bind:checked="isSubSectionAdded(subsection)"
                                    v-bind:text="subsection" class="mt-1 pl-2"></input-checkbox>
                  </div>
                </div>
              </div>
            </div>





            <div class="row mt-3">
              <div class="col-lg-12 custom-form-label">
                {{$t('workspace_default_language')}}
              </div>
            </div>
            <div class="form-group row mt-1">
              <div class="col-lg-12">
                <select class="form-control" v-bind:id="'select_lang_' +  getId()">
                  <option value="en-US">English</option>
                  <option value="no">Norweigian</option>
                  <option value="pt">Portuguese</option>
                  <option value="sv">Swedish</option>

                </select>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-lg-12 custom-form-label">
                {{$t('workspace_start_view')}}
              </div>
            </div>
            <div class="form-group row mt-1">
              <div class="col-lg-12">
                <select class="form-control" v-bind:id="'select_startpage_' +  getId()">
                  <option :value="`/${domain}/{0}/news`" v-if="$store.getInstallationType() != 'Education'">{{$t('menu_news')}}</option>
                  <option :value="`/${domain}/{0}/Todo`" v-if="$store.getInstallationType() != 'Education'">{{$t('menu_todo')}}</option>
                  <option value="/education/{0}/news" v-if="$store.getInstallationType() == 'Education'">{{$t('menu_news')}}</option>
                  <option value="/education/{0}/Todo" v-if="$store.getInstallationType() == 'Education'">{{$t('menu_todo')}}</option>
                </select>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-lg-12 custom-form-label">
                {{$t('workspace_appearance')}}
              </div>
            </div>
            <div class="form-group row mt-1">
              <div class="col-lg-12">
                <select class="form-control" v-bind:id="'select_skin_' +  getId()">
                  <option v-for="skin in skins" v-bind:value="skin.ReferenceName">{{skin.Name}}</option>
                  <option value="default">default</option>
                  <option value="business">business</option>
                  <option value="coffee" v-if="false">coffee</option>
                  <option value="environment" v-if="false">environment</option>
                  <option value="health" v-if="false">health</option>
                  <option value="power">power</option>
                  <option value="office">office</option>
                  <option value="bumblebee">bumblebee</option>
                  <option value="education">education</option>
                  <option value="ideate">ideate</option>
                </select>
              </div>
            </div>

            <div class="row mt-3" v-show="$store.getUserPermissionLevel() > 5">
              <div class="col-lg-12 custom-form-label">
                {{$t('installation_type')}}
              </div>
            </div>
            <div class="form-group row mt-1" v-show="$store.getUserPermissionLevel() > 5">
              <div class="col-lg-12">
                <select class="form-control" v-bind:id="'select_installationtype_' +  getId()">
                  <option value="">default</option>
                  <option value="Arts_Entertainment">Arts/Entertainment</option>
                  <option value="Business_Services">Business Services</option>
                  <option value="Construction">Construction</option>
                  <option value="Consumer_Goods_Retail">Consumer Goods/Retail</option>
                  <option value="Coaching">Coaching</option>
                  <option value="Education">Education</option>
                  <option value="Education2">Education2</option>
                  <option value="Financial">Financial</option>
                  <option value="Fitness_Sports">Fitness/Sports</option>
                  <option value="Food_Hospitality">Food/Hospitality</option>
                  <option value="Government">Government</option>
                  <option value="Home_Services">Home_Services</option>
                  <option value="Legal">Legal</option>
                  <option value="Manufacturing">Manufacturing</option>
                  <option value="Marketing">Marketing</option>
                  <option value="Medical_Healthcare">Medical/Healthcare</option>
                  <option value="Non-Profit">Non-Profit</option>
                  <option value="Other">Other</option>
                  <option value="Real_Estate">Real Estate</option>
                  <option value="Parking">Parking</option>
                  <option value="Software_Technology">Software/Technology</option>
                </select>
              </div>
            </div>
            <div class="form-group row mt-3">
              <div class="col-lg-12">
                <input-checkbox @input="setOverrideUserRegistrationEmail" v-bind:id="'chk_enableUserRegistrationEmail_' +  getId()"
                                v-bind:name="'chk_enableUserRegistrationEmail_' +  getId()" v-bind:checked="isUserRegistrationEmailEnable"
                                v-bind:text="$store.translate('enable_user_registration_email')" class="mt-1"></input-checkbox>
              </div>
            </div>
            <div class="form-group row mt-3">
              <div class="col-lg-12">
                <input-checkbox @input="setOverrideTaskChangeEmail" v-bind:id="'chk_enableTaskChangeEmail_' +  getId()"
                                v-bind:name="'chk_enableTaskChangeEmail_' +  getId()" v-bind:checked="isTaskChangeEmailEnable"
                                v-bind:text="$store.translate('enable_task_change_email')" class="mt-1"></input-checkbox>
              </div>
            </div>

            <div class="form-group row mt-3">
              <div class="col-lg-12">
                <input-checkbox @input="setOverrideTaskEmail" v-bind:id="'chk_disableTaskEmail_' +  getId()"
                                v-bind:name="'chk_disableTaskEmail_' +  getId()" v-bind:checked="isTaskEmailDisable"
                                v-bind:text="$store.translate('disable_task_email')" class="mt-1"></input-checkbox>
              </div>
            </div>

            <div class="form-group row mt-3">
              <div class="col-lg-12">
                <input-checkbox @input="setOverrideDisableLocation" v-bind:id="'chk_disableDisableLocation_' +  getId()"
                                v-bind:name="'chk_disableDisableLocation_' +  getId()" v-bind:checked="isDisableLocation"
                                v-bind:text="$store.translate('disable_user_location')" class="mt-1"></input-checkbox>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-lg-12 custom-form-label">
                {{ $store.translate('items_on_todo_page')}}
              </div>
            </div>
            <div class="form-group row mt-1">
              <div class="col-lg-12">
                <select class="form-control" v-bind:id="'select_todopage_' +  getId()">
                  <option value="">Select page</option>
                  <option value="30">30</option>
                  <option value="50">50</option>
                  <option value="80">80</option>
                  <option value="100">100</option>
                </select>
              </div>
            </div>
            <div class="form-group row mt-3">
              <div class="col-lg-12">
                <input-checkbox @input="setOverrideEmailReminder" v-bind:value="1" v-bind:id="'chk1_' +  getId()"
                                v-bind:name="'chk1_' +  getId()" v-bind:checked="isShiftReminderEmailEnable"
                                v-bind:text="$t('enable_shiftreminder_email')" class="mt-1"></input-checkbox>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-lg-12 custom-form-label">
                {{ $store.translate('shift_reminder_before_minutes')}}
              </div>
            </div>
            <div class="form-group row mt-1">
              <div class="col-lg-12">
                <select class="form-control" v-bind:id="'select_reminder_' +  getId()">
                  <option value="">Select time(in minutes)</option>
                  <option value="30">30</option>
                  <option value="60">60</option>
                  <option value="90">90</option>
                  <option value="120">120</option>
                </select>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-lg-12 custom-form-label">
                {{$t('site_timezone')}}
              </div>
            </div>
            <div class="form-group row mt-1">
              <div class="col-lg-12">
                <select class="form-control" v-bind:id="'select_timezone_' +  getId()">
                  <option value="">{{ $t('select_timezone') }}</option>
                  <option v-for="timezone in timezones" v-bind:value="timezone.Id">
                    {{ timezone.Name }}
                  </option>
                </select>
              </div>
            </div>


            <div class="row mt-3">
              <div class="col-lg-12 custom-form-label">
                {{$t('email')}}
              </div>
            </div>
            <div class="form-group row mt-1">
              <div class="col-lg-12">
                <input v-model="email" type="text" id="txtemail" v-bind:placeholder="$t('email')" maxlength="100" name="email" class="form-control" />
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-lg-12 custom-form-label">
                {{$t('user_invitation_group')}}
              </div>
            </div>
            <div class="form-group row mt-1">
              <div class="col-lg-12">
                <select class="form-control" v-bind:id="'select_invitation_group_' +  getId()">
                  <option value="">Select invitation group</option>
                  <option value="Pending">Pending</option>
                  <option value="User">User</option>
                </select>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-lg-12 custom-form-label">
                {{$t('news_view_date')}}
              </div>
            </div>
            <div class="form-group row mt-1">
              <div class="col-lg-12">
                <input type="text" id="txtnewsviewdate" v-bind:placeholder="$t('date')" maxlength="50" name="txtnewsviewdate" class="form-control schedulerstartdate" />
              </div>
            </div>


            <div class="form-group row text-right">
              <div class="col-lg-12 mt-1">
                <button @click="updateSetting" type="submit" class="btn skin primary-button mt-1"><i class="icon-cog5 mr-2"></i> {{$t('save')}}</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import InputCheckbox from "../form-components/input-checkbox.vue";
  var isShiftDisable = false;
  var isTaskEmailDisable = false;
  var isDisableLocation = false;
  var isTaskChangeEmailDisable = false;
  var isShiftReminderEmailEnable = false;
  var timezones = [];
  var subSections = ["Members-Clients"];
  var addedSections = [];
  var addedSubSections = [];
  var email = '';
  var domain = 'home';
  export default {

    name: "admin-general-setting",
    components: {
      InputCheckbox,
    },
    props: {
      domain: {
        required: true,
        type: String,
        default: "home"
      },
    },
    data() {
      return {
        isShiftDisable: false,
        isTaskEmailDisable: false,
        isDisableLocation:false,
        isTaskChangeEmailEnable: false,
        isUserRegistrationEmailEnable: false,
        isShiftReminderEmailEnable: false,
        timezones: [],
        skins: [],
        sections: [
          {
            "sectionname": "Members",
            "subsections": ["Clients"]
          },
          {
            "sectionname": "Projects",
            "subsections": []
          },
          {
            "sectionname": "Locations",
            "subsections": []
          },
          {
            "sectionname": "Shifts",
            "subsections": []
          },
          {
            "sectionname": "Planning",
            "subsections": ["Tasks"]
          },
          {
            "sectionname": "Bookings",
            "subsections": []
          },
        ],//["Members", "Projects", "Locations", "Shifts", "Planning"],
        addedSections: [],
        addedSubSections: [],
        email: '',
      };
    },
    computed: {

    },

    methods: {
      isSubSectionAdded(subsection) {
        var index = this.addedSubSections.indexOf(subsection);
        if (index > -1) {
          return true;
        }
        return false;
      },
      isSectionAdded(section) {
        var index = this.addedSections.indexOf(section);
        if (index > -1) {
          return true;
        }
        return false;
      },
      setSectionOverride(checked, val, value) {
        var index = this.addedSections.indexOf(val);
        if (index > -1) {
          this.addedSections.splice(index, 1)
        }
        if (checked) {
          this.addedSections.push(val);
        }

        // special case for the time for shifts
        var index = this.addedSections.indexOf("Shifts");
        if (index > -1) {
          index = this.addedSubSections.indexOf("ScheduleUsers");
          if (index > -1) {
            this.addedSubSections.splice(index, 1)
          }
          index = this.addedSubSections.indexOf("Shifts");
          if (index > -1) {
            this.addedSubSections.splice(index, 1)
          }
          this.addedSubSections.push("ScheduleUsers");
          this.addedSubSections.push("Shifts");
        }
        console.log(this.addedSections);
      },

      setSubSectionOverride(checked, val, value) {
        var index = this.addedSubSections.indexOf(val);
        if (index > -1) {
          this.addedSubSections.splice(index, 1)
        }
        if (checked) {
          this.addedSubSections.push(val);
        }

        console.log(this.addedSubSections);
      },

      clearFields() {

        $("#select_skin_" + this.getId()).val('default');
        $("#select_skin_" + this.getId()).trigger('change');

        $("#select_startpage_" + this.getId()).val('/home/{0}/news');
        $("#select_startpage_" + this.getId()).trigger('change');

        $("#select_lang_" + this.getId()).val('en-US');
        $("#select_lang_" + this.getId()).trigger('change');

        $("#select_reminder_" + this.getId()).val('');
        $("#select_reminder_" + this.getId()).trigger('change');

        $("#select_todopage_" + this.getId()).val('');
        $("#select_todopage_" + this.getId()).trigger('change');
        

        $("#select_timezone_" + this.getId()).val('');
        $("#select_timezone_" + this.getId()).trigger('change');

        $("#select_installationtype_" + this.getId()).val('');
        $("#select_installationtype_" + this.getId()).trigger('change');

        $("#select_invitation_group_" + this.getId()).val('');
        $("#select_invitation_group_" + this.getId()).trigger('change');

        

        this.isShiftDisable = false;
        this.isTaskEmailDisable = false;
        this.isDisableLocation = false;
        this.isTaskChangeEmailEnable = false;
        this.isUserRegistrationEmailEnable = false;
        this.isShiftReminderEmailEnable = false;
        this.email = '';
      },
      setOverride(checked, val, value) {
        this.isShiftDisable = checked;
      },
      setOverrideDisableLocation(checked, val, value) {
        this.isDisableLocation = checked;
      },
      setOverrideTaskEmail(checked, val, value) {
        this.isTaskEmailDisable = checked;
      },
      setOverrideTaskChangeEmail(checked, val, value) {
        this.isTaskChangeEmailEnable = checked;
      },
      setOverrideUserRegistrationEmail(checked, val, value) {
        this.isUserRegistrationEmailEnable = checked;
      },
      setOverrideEmailReminder(checked, val, value) {
        this.isShiftReminderEmailEnable = checked;
      },
      getId() {
        return this._uid;
      },
      loadtimezones() {
        var thisContext = this;
        try {
          this.timezones = [];
          var url = '/api/Admin/v1/Timezones';
          this.$http.get(url).then(response => {
            thisContext.timezones = response.data;
            thisContext.$forceUpdate();
          });
        }
        catch (err) {
          alert("err")
        }
      },
      async updateSetting() {

        //if (!$('#createShiftForm').valid())
        //  return false;
        var newsResetDate = $("#txtnewsviewdate").val();
        if (newsResetDate !== '') {
          newsResetDate = convertNormalDate(newsResetDate);
        }

        var todopage = $('#select_todopage_' + this.getId()).val();
        if (todopage === '') {
          todopage = 50;
        }
        var request = {
          isDisableShift: this.isShiftDisable, relativePath: $('#select_startpage_' + this.getId()).val(),
          lang: $('#select_lang_' + this.getId()).val(), skin: $('#select_skin_' + this.getId()).val(),
          shiftremindertime: $('#select_reminder_' + this.getId()).val(),
          timezone: $('#select_timezone_' + this.getId()).val(), isEnableReminderEmail: this.isShiftReminderEmailEnable,
          sections: this.addedSections, subSections: this.addedSubSections,
          installationtype: $('#select_installationtype_' + this.getId()).val(),
          invitationgroup: $('#select_invitation_group_' + this.getId()).val(),
          email: this.email, isTaskEmailDisable: this.isTaskEmailDisable,
          isTaskChangeEmailEnable: this.isTaskChangeEmailEnable,
          isUserRegistrationEmailEnable: this.isUserRegistrationEmailEnable,
          todopagepagging: todopage, isDisableLocation: this.isDisableLocation, newsResetDate: newsResetDate
        };

        try {
          var response = await this.$http.put(
            '/api/Admin/v1/Site',
            request
          ).then(async response => {
            location.reload(true);
          });

        } catch (err) {
          alert(err);
        }
      },
      getSetting() {
        try {
          var url = '/api/Sites/v1/detail';
          this.$http.get(url).then(async response => {
            var data = response.data;
            console.log(data);
            this.isShiftDisable = data.isShiftDisable;
            this.isTaskEmailDisable = data.isTaskEmailDisable;
            this.isDisableLocation = data.isDisableLocation;
            this.isTaskChangeEmailEnable = data.isTaskChangeEmailEnable;
            this.isUserRegistrationEmailEnable = data.isUserRegistrationEmailEnable;
            this.isShiftReminderEmailEnable = data.isEnableShiftReminderEmail;
            $("#select_reminder_" + this.getId()).val(data.shiftReminderTime);
            $("#select_reminder_" + this.getId()).trigger('change');

            $("#select_todopage_" + this.getId()).val(data.todopagepagging);
            $("#select_todopage_" + this.getId()).trigger('change');
            

            if (data.Skin !== '' && data.Skin !== null) {
              $("#select_skin_" + this.getId()).val(data.Skin);
              $("#select_skin_" + this.getId()).trigger('change');
            }

            if (data.RelativePath !== '' && data.RelativePath !== null) {
              $("#select_startpage_" + this.getId()).val(data.RelativePath);
              $("#select_startpage_" + this.getId()).trigger('change');
            }

            if (data.PreferredLanguage !== '' && data.Skin !== null) {
              $("#select_lang_" + this.getId()).val(data.PreferredLanguage);
              $("#select_lang_" + this.getId()).trigger('change');
            }

            if (data.Timezone !== '' && data.Timezone !== null) {
              $("#select_timezone_" + this.getId()).val(data.Timezone);
              $("#select_timezone_" + this.getId()).trigger('change');
            }

            //if (data.InstallationType !== '' && data.InstallationType !== null) {
            $("#select_installationtype_" + this.getId()).val(data.InstallationType);
            $("#select_installationtype_" + this.getId()).trigger('change');
            //}

            $("#select_invitation_group_" + this.getId()).val(data.InvitationGroup);
            $("#select_invitation_group_" + this.getId()).trigger('change');
            

            if (data.sections !== '' && data.sections !== null) {
              this.addedSections = data.sections;
            }
            if (data.subSections !== '' && data.subSections !== null) {
              this.addedSubSections = data.subSections;
            }
            this.email = data.Email;
            $("#txtnewsviewdate").val(data.NewsNotiResetDate);
            this.$forceUpdate();
          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      getSkins() {
        try {
          var url = '/api/Skin/Search?searchTerm';
          this.$http.get(url).then(async response => {
            var validSkins = [];
            for (var i = 0; i < response.data.length; i++) {
              if (response.data[i].Published == true)
                validSkins.push(response.data[i])
            }
            this.skins = validSkins;

            this.$forceUpdate();
          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
    },
    mounted() {
      this.loadtimezones();
      this.getSkins();

      var locale = $.datepicker.regional[this.$store.getLocale()];
      var d = this.$store.getMomentLocale(new Date());

      var settings = {
        autoUpdateInput: false,
        locale: locale,
        startDate: d,
        singleDatePicker: true,
        showDropdowns: true,
        minYear: 1901,
        maxYear: parseInt(moment().format('YYYY'), 10),
        drops: "up"
      };

      var thisContext = this;

      $('.schedulerstartdate').daterangepicker(settings);

      $('.schedulerstartdate').on('apply.daterangepicker', function (ev, picker) {
        var tmp = thisContext.$store.getMomentLocale(picker.startDate);
        $(this).val(tmp.format("L"));
      });

      $('.schedulerstartdate').val("")
    },
    created: function () {

    },
    watch: {
    },
  };

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/general/admin-general-setting.vue